var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloudIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4.8,
    fill: "#52C41A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_636_1766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6287 6.85645H18.1716C18.308 6.85645 18.4388 6.91063 18.5353 7.00708C18.6317 7.10352 18.6859 7.23433 18.6859 7.37073V15.5993C18.6859 15.7357 18.6317 15.8665 18.5353 15.963C18.4388 16.0594 18.308 16.1136 18.1716 16.1136H5.82874C5.69234 16.1136 5.56153 16.0594 5.46508 15.963C5.36864 15.8665 5.31445 15.7357 5.31445 15.5993V7.37073C5.31445 7.23433 5.36864 7.10352 5.46508 7.00708C5.56153 6.91063 5.69234 6.85645 5.82874 6.85645H7.3716",
    stroke: "white",
    strokeWidth: 1.02857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9717 16.1143L9.94312 18.6857",
    stroke: "white",
    strokeWidth: 1.02857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0288 16.1143L14.0574 18.6857",
    stroke: "white",
    strokeWidth: 1.02857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91455 18.6855H15.086",
    stroke: "white",
    strokeWidth: 1.02857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4345 7.22706C11.4788 7.11302 11.5565 7.01502 11.6575 6.94592C11.7584 6.87682 11.8779 6.83984 12.0003 6.83984C12.1226 6.83984 12.2421 6.87682 12.343 6.94592C12.444 7.01502 12.5217 7.11302 12.566 7.22706L13.2243 8.91392H14.9831C15.1082 8.91576 15.2298 8.95493 15.3325 9.0264C15.4351 9.09788 15.514 9.1984 15.5591 9.31506C15.5938 9.4245 15.5968 9.54154 15.5677 9.65261C15.5386 9.76367 15.4785 9.86419 15.3945 9.94249L13.8414 11.3208L14.4997 12.6373C14.5593 12.7529 14.5795 12.8848 14.5572 13.0129C14.5349 13.1411 14.4714 13.2584 14.3763 13.3471C14.2835 13.4397 14.1632 13.4998 14.0334 13.5183C13.9036 13.5368 13.7713 13.5128 13.6563 13.4499L12.0003 12.5448L10.3443 13.4499C10.2292 13.5128 10.0969 13.5368 9.96714 13.5183C9.83735 13.4998 9.71705 13.4397 9.62426 13.3471C9.52914 13.2584 9.46561 13.1411 9.44333 13.0129C9.42105 12.8848 9.44124 12.7529 9.50083 12.6373L10.1591 11.3208L8.60597 9.94249C8.51404 9.86084 8.44908 9.75319 8.41969 9.6338C8.3903 9.51441 8.39787 9.38891 8.4414 9.27392C8.49273 9.16495 8.57433 9.07307 8.67647 9.00923C8.77861 8.94539 8.89696 8.9123 9.0174 8.91392H10.7763L11.4345 7.22706Z",
    stroke: "white",
    strokeWidth: 1.02857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_636_1766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.4,
    height: 14.4,
    fill: "white",
    transform: "translate(4.80005 4.7998)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudIcon);
export default __webpack_public_path__ + "static/media/cloud_icon.77f443474c7c4503d8ed5fe939b80918.svg";
export { ForwardRef as ReactComponent };